import React from "react";
import SingleMetricCard from "./single-metric";
import {
  capitalizeFirstLetter,
  getStatusColor,
  getStatusTextColor,
} from "../../../../utilz/function";
import InventorySingleTable from "./inventory-single-table";
import Icon from "../../../../assets/icons";

interface MetricsData {
  totalSuppliers: number;
  pendingApproval: number;
  activeSuppliers: number;
  suspendedSuppliers: number;
  totalRevenue: number
}

const SingleProduct = ({ information, data }: any) => {
  const metrics: MetricsData = {
    totalSuppliers: 1.2,
    pendingApproval: 30,
    activeSuppliers: 85,
    suspendedSuppliers: 5,
    totalRevenue : 0
  };

  console.log(information)
  return (
    <>
      {metrics && <SingleMetricCard metrics={metrics} information={information} />}
      <div className="flex gap-6">
        <div className="bg-white rounded-3xl shadow border w-full border-[#C9C9C9]">
          <h2 className="text-lg font-semibold mb-4 px-6 pt-3 ">
            Item Information
          </h2>

          <div className="border-t pt-4 p-6">
            <div className="grid grid-cols-2 gap-x-4 gap-y-6">
              <div>
                <p className="text-gray-500 text-sm mb-1">Product Name</p>
                <p className="font-medium">
                  {capitalizeFirstLetter(information?.name) || "N/A"}
                </p>
              </div>

              <div className="flex justify-between">
                <div>
                  <p className="text-gray-500 text-sm mb-1">SKU</p>
                  <p className="font-medium">{information?.sku || "TOM-001"}</p>
                </div>
                <button className="text-gray-400 self-start">
                  <Icon name="copyIcon" />
                </button>
              </div>

              <div>
                <p className="text-gray-500 text-sm mb-1">Category</p>
                <p className="font-medium">
                  {capitalizeFirstLetter(information?.category || "Premium")}
                </p>
              </div>

              <div>
                <p className="text-gray-500 text-sm mb-1">
                  Unit of Measurement
                </p>
                <p className="font-medium">
                  {information?.measurementUnit || "Kilogram (kg)"}
                </p>
              </div>

              <div>
                <p className="text-gray-500 text-sm mb-1">Price</p>
                <p className="font-medium">₦{information?.price || "600"}</p>
              </div>

              <div>
                <p className="text-gray-500 text-sm mb-1">Product Status</p>
                <div
                  className="inline-flex items-center py-0.5 rounded-full text-xs font-medium"
                  style={{
                    backgroundColor: getStatusColor(
                      information?.approvalStatus
                    ),
                    color: getStatusTextColor(information?.approvalStatus),
                  }}
                >
                  {capitalizeFirstLetter(information?.approvalStatus) || "N/A"}
                </div>
              </div>

              <div className="col-span-2">
                <p className="text-gray-500 text-sm mb-1">Description</p>
                <p className="text-gray-700 text-sm">
                  {capitalizeFirstLetter(information?.description) || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <InventorySingleTable data={information} />
      </div>
    </>
  );
};

export default SingleProduct;
